import React, {useState, useEffect, useRef} from 'react';
import { useParams } from 'react-router';
import {Link, useNavigate} from 'react-router-dom';
import axios from 'axios';
import '../config.js';

import { alertService } from '../services/alert.service.js';
import ProductBasicInfo from '../components/productBasicInfo.js';
import ImagePicker from '../components/imagePicker.js';
import ProductAdditionalInfo from '../components/productAdditionalInfo.js'
import ProductItineraryInfo from '../components/productItineraryInfo.js'
import Progress from '../components/progress.js';

function Product(props) {
  const { id, subnav } = useParams();
  const [item, setItem] = useState({});
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [version, setVersion] = useState(1);

  useEffect(()=>{
    axios.get(global.config.api_server+'product?id='+id+'&token='+localStorage.getItem("token")) 
    .then(res => {
      if(res.status === 200 && res.data.status === "success"){
        setItem(res.data.product);
        setLoading(false);
      }else{
        alertService.error(res.data.error);
      }
    }).catch(err => {
      alertService.error(err);
      navigate("/products");
    });
  }, [version]);
  
  const handleDelete = (event) => {
    event.preventDefault();
    if(id){
      axios.get(global.config.api_server+'client?id='+id+'&token='+localStorage.getItem("token")).then(res => {
        if(res.status === 200 && res.data.status === "success"){
          alertService.success('Product deleted');
          navigate("/products");
        }else{
          alertService.error(res.data.error);
        }
      }).catch(err => {
        alertService.error(err);
      });
    }else{
      alertService.error('Invalid Input');
    }
  }
  
  const checkSubNav = (param) => {
    let design = "";
    if(subnav === param){
      design = " disabled";
    }else if(param === 'basic' && (subnav === null || subnav === undefined)){
      design = " disabled";
    }
    return design;
  }

  const incrementVersion = (isSaved = false) => {
    if(isSaved){
      setVersion(version => version + 1);
    }
  }

  let subnavItem = <ProductBasicInfo id={id} item={item} triggerPostSave={incrementVersion}></ProductBasicInfo>;
  if(subnav === 'images'){
    subnavItem = <ImagePicker id={id} item={item} type="PRODUCT" limit={0}></ImagePicker>;
  }else if(subnav === 'additional'){
    subnavItem = <ProductAdditionalInfo id={id} item={item} triggerPostSave={incrementVersion}></ProductAdditionalInfo>;
  }else if(subnav === 'itinerary'){
    subnavItem = <ProductItineraryInfo id={id} item={item} triggerPostSave={incrementVersion}></ProductItineraryInfo>;
  }
  if(loading){
    return <Progress/>;
  }else{
    return(
      <div className="container-fluid">
        <div className="mb-3">
          <button className={'btn btn-icon-split float-right btn-danger'} data-toggle="modal" data-target="#deleteProductModal">
            <span className="icon text-white-50">
              <i className="fas fa-trash"></i>
            </span>
            <span className="text">Delete</span>
          </button>
          <Link to={"/products"} className="btn btn-light btn-icon-split mr-2">
            <span className="icon text-white-50">
              <i className="fas fa-arrow-left"></i>
            </span>
            <span className="text">Back</span>
          </Link>
          <Link to={"/product/"+id} className={'btn btn-icon-split mr-2 btn-primary' + checkSubNav('basic')}>
            <span className="icon text-white-50">
              <i className="fas fa-info"></i>
            </span>
            <span className="text">Basic Info</span>
          </Link>
          <Link to={"/product/"+id+"/additional"} className={'btn btn-icon-split mr-2 btn-primary' + checkSubNav('additional')}>
            <span className="icon text-white-50">
              <i className="fas fa-ad"></i>
            </span>
            <span className="text">Additional Info</span>
          </Link>
          <Link to={"/product/"+id+"/itinerary"} className={'btn btn-icon-split mr-2 btn-primary' + checkSubNav('itinerary')}>
            <span className="icon text-white-50">
              <i className="fas fa-swatchbook"></i>
            </span>
            <span className="text">Technical Info</span>
          </Link>
          <Link to={"/product/"+id+"/images"} className={'btn btn-icon-split mr-2 btn-primary' + checkSubNav('images')}>
            <span className="icon text-white-50">
              <i className="fas fa-image"></i>
            </span>
            <span className="text">Images</span>
          </Link>
        </div>
        
        {subnavItem}
        
        <div className="modal fade" id="deleteProductModal" tabIndex="-1" role="dialog" aria-labelledby="delete-popup" aria-hidden="true">
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="delete-client-popup">Confirm deletion?</h5>
                <button className="close" type="button" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">Are you sure, you want to delete this product?</div>
              <div className="modal-footer">
                <button className="btn btn-default" type="button" data-dismiss="modal">Cancel</button>
                <button className={'btn ml-3 btn-danger'} onClick={handleDelete} data-dismiss="modal">Delete</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Product;